import { render, staticRenderFns } from "./ManufacturerPicker.vue?vue&type=template&id=a3b334c2&"
import script from "./ManufacturerPicker.vue?vue&type=script&lang=js&"
export * from "./ManufacturerPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports